module.exports = __webpack_public_path__ + "img/checked01.04b37d00.svg";